import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rt-tutorial-dialog-nav',
  templateUrl: './tutorial-dialog-nav.component.html',
  styleUrls: ['./tutorial-dialog-nav.component.less'],
  standalone: true,
})
export class TutorialDialogNavComponent {
  @Input() public active: number = 3;

  @Input()
  public set count(val: number) {
    this.iterableArr = this.createArray(val);
  }

  @Output() public select: EventEmitter<number> = new EventEmitter();

  public iterableArr: number[] = [];

  public trackBy(_index: number, item: number): number {
    return item;
  }

  private createArray(count: number): number[] {
    return Array.from(Array(count).keys());
  }
}
